module.exports = "/images/manila-bulletin.png?7eebdcdf37feff133a7b2d37fd8da4aa";